const hasCargaOperation = (operation) => {
  if (Array.isArray(operation)) {
    return operation.includes("carga");
  }
  return operation === "carga";
};

const hasDescargaOperation = (operation) => {
  if (Array.isArray(operation)) {
    return operation.includes("descarga");
  }
  return operation === "descarga";
};

const isLoadingStopPoint = (stop) =>
  hasCargaOperation(stop?.operation) ||
  String(stop?.typeOperation || "")
    .trim()
    .toUpperCase() === "LOADING";

const isUnloadingStopPoint = (stop) =>
  hasDescargaOperation(stop?.operation) ||
  String(stop?.typeOperation || "")
    .trim()
    .toUpperCase() === "UNLOADING";

const hasNonEmptyStopDocs = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "string") return value.trim().length > 0;
  if (value && typeof value === "object") {
    return Object.keys(value).length > 0;
  }
  return Boolean(value);
};

/**
 * Pendências que impedem finalizar (espelha a API).
 * Coleta: LOADING_COMPLETED + nota (invoices ou documents do app) + attachments.
 * Entrega: UNLOADING_COMPLETED + canhoto.
 */
const hasTransportedInvoice = (stop) =>
  hasNonEmptyStopDocs(stop?.invoices) || hasNonEmptyStopDocs(stop?.documents);

export const collectFinalizeBlockers = (stoppingPoints = []) => {
  const blockers = [];

  (Array.isArray(stoppingPoints) ? stoppingPoints : []).forEach(
    (stop, index) => {
      const order =
        typeof stop?.stop_order === "number" ? stop.stop_order : index + 1;
      const name = String(stop?.name || "").trim();
      const label = name ? `Ponto ${order} (${name})` : `Ponto ${order}`;

      if (isLoadingStopPoint(stop)) {
        const loadingStatus = String(stop?.loadingStatus || "")
          .trim()
          .toUpperCase();
        if (loadingStatus !== "LOADING_COMPLETED") {
          blockers.push(
            `${label}: coleta não concluída (status ${loadingStatus || "ausente"}).`,
          );
        }
        if (!hasTransportedInvoice(stop)) {
          blockers.push(`${label}: falta Nota Fiscal Transportada.`);
        }
        if (!hasNonEmptyStopDocs(stop?.attachments)) {
          blockers.push(
            `${label}: falta Documentação de transporte (attachments).`,
          );
        }
      }

      if (isUnloadingStopPoint(stop)) {
        const unloadingStatus = String(stop?.unloadingStatus || "")
          .trim()
          .toUpperCase();
        if (unloadingStatus !== "UNLOADING_COMPLETED") {
          blockers.push(
            `${label}: entrega não concluída (status ${unloadingStatus || "ausente"}).`,
          );
        }
        const canhotos = Array.isArray(stop?.canhoto)
          ? stop.canhoto
          : stop?.canhoto
            ? [stop.canhoto]
            : [];
        const hasCanhoto = canhotos.some((item) => {
          if (typeof item === "string") return item.trim().length > 0;
          if (item && typeof item === "object") {
            return String(item.url || item.canhoto || "").trim().length > 0;
          }
          return false;
        });
        if (!hasCanhoto) {
          blockers.push(`${label}: falta canhoto de entrega.`);
        }
      }
    },
  );

  return blockers;
};
